import { api } from '@/store/api'
import type { Lang } from '@/types/lang'

/** Страна из справочника api (ISO 3166-1, тот же, что у веб-академии). */
export interface ICountry {
  code: string
  nameEn: string
  nameRu: string
}

export const countriesApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Справочник статичный — держим сутки, как веб-академия.
    countries: build.query<ICountry[], void>({
      query: () => 'countries',
      keepUnusedDataFor: 86400,
    }),
  }),
})

export const { useCountriesQuery } = countriesApi

export const countryName = (country: ICountry, lang: Lang): string =>
  lang === 'ru' ? country.nameRu : country.nameEn

/** Как в веб-академии: подстрока ищется сразу в ru- и en-названии и в коде страны. */
export const filterCountries = (countries: ICountry[], query: string): ICountry[] => {
  const normalized = query.trim().toLowerCase()
  if (!normalized) return countries

  return countries.filter(
    (country) =>
      country.nameRu.toLowerCase().includes(normalized) ||
      country.nameEn.toLowerCase().includes(normalized) ||
      country.code.toLowerCase().includes(normalized),
  )
}
